import axios, { AxiosError, AxiosResponse } from 'axios'
import { BASE_API_URL, CREATE_LEAD_WITH_TOKEN_ENDPOINT } from './api'

export const affiliateCreateLead = (params: {
  email: string
  firstName: string
  lastName: string
  phone: string
  token: string
  description?: string
}): Promise<any> => {
  const { email, firstName, lastName, phone, token, description } = params
  return axios
    .post(
      `${BASE_API_URL}${CREATE_LEAD_WITH_TOKEN_ENDPOINT}?affiliateToken=${token}`,
      {
        email,
        firstName,
        lastName,
        phone,
        description,
      }
    )
    .then((response: AxiosResponse) => response.data)
    .catch((err: AxiosError) => {
      if (err.response) return err.response.data
      return err
    })
}
